






























































import {
  ChillPayMainPaymentChannel,
  ChillPayPaymentChannel,
  FinanceType,
  LoadingStatusType,
  TransactionType,
  TypeComponentNoti,
} from "@/enums/enums";
import { MerchantId } from "@/helper/authenticationHelper";
import { GetURLName } from "@/helper/documentHelper";
import { IsKeyBoardEN, ValidateEmailFormatError } from "@/helper/shareHelper";
import {
  ChillPayRequestModel,
  DataPaySolutionPaymentModel,
  PaySolutionRequestModel,
} from "@/model/payment/paymentModel";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StorePayment = namespace("Payment");
const StoreLoading = namespace("Loading");
const StoreAlert = namespace("Alert");
const StoreMerchant = namespace("Merchant");

const urlImg = process.env.VUE_APP_PeakBlobStorage + "peakengine/Content/Image/";

@Component
export default class ModalInfoToConfirmPaymentChillPay extends Vue {
  @Prop({ default: 0 }) transactionId!: number;
  @Prop({ default: TransactionType.None }) transactionType!: TransactionType;
  @Prop({ default: FinanceType.None }) financeType!: FinanceType;
  @Prop({ default: 30 }) timeWaitingPayment!: number;

  private showModal = true;
  private isShowFormSubmit = false;

  private mainPaymentChannel: any = [];
  private pickMainPaymentChannel: ChillPayMainPaymentChannel = ChillPayMainPaymentChannel.QRPromptPay;

  private paymentChannel: any = [];
  private pickPaymentChannel = ChillPayPaymentChannel.None;

  private internetBanking: any = [
    [
      {
        value: ChillPayPaymentChannel.InternetBank_Bay,
        name: this.$t("ChillPay_InternetBanking.Bay"),
        imgUrl: urlImg + "BankLogo/BAY.png",
      },
    ],
    [
      {
        value: ChillPayPaymentChannel.InternetBank_Bbl,
        name: this.$t("ChillPay_InternetBanking.Bbl"),
        imgUrl: urlImg + "BankLogo/BBL.png",
      },
    ],
    [
      {
        value: ChillPayPaymentChannel.InternetBank_Scb,
        name: this.$t("ChillPay_InternetBanking.Scb"),
        imgUrl: urlImg + "BankLogo/SCB.png",
      },
    ],
    [
      {
        value: ChillPayPaymentChannel.InternetBank_Ktb,
        name: this.$t("ChillPay_InternetBanking.Ktb"),
        imgUrl: urlImg + "BankLogo/KTB.png",
      },
    ],
    [
      {
        value: ChillPayPaymentChannel.InternetBank_Ttb,
        name: this.$t("ChillPay_InternetBanking.Ttb"),
        imgUrl: urlImg + "BankLogo/TTB.png",
      },
    ],
  ];
  private mobilePayment: any = [
    [
      {
        value: ChillPayPaymentChannel.MobileBank_Scb,
        name: "SCB Easy",
        imgUrl: urlImg + "BankLogo/SCB.png",
      },
    ],
    [
      {
        value: ChillPayPaymentChannel.PayPlus_Kbank,
        name: "K PLUS",
        imgUrl: urlImg + "BankLogo/KBANK.png",
      },
    ],
    [
      {
        value: ChillPayPaymentChannel.MobileBank_Bbl,
        name: "Bualuang mBanking",
        imgUrl: urlImg + "BankLogo/BBL.png",
      },
    ],
    [
      {
        value: ChillPayPaymentChannel.MobileBank_Bay,
        name: "KMA App",
        imgUrl: urlImg + "BankLogo/BAY.png",
      },
    ],
    [
      {
        value: ChillPayPaymentChannel.MobileBank_Ktb,
        name: "Krungthai Next",
        imgUrl: urlImg + "BankLogo/KTB.png",
      },
    ],
  ];
  private eWallet: any = [
    [
      {
        value: ChillPayPaymentChannel.EWallet_LinePay,
        name: "LINE PAY",
        imgUrl: urlImg + "EwalletLogo/LinePay.png",
      },
    ],
    [
      {
        value: ChillPayPaymentChannel.EWallet_TrueMoney,
        name: "True Money Wallet",
        imgUrl: urlImg + "EwalletLogo/TrueWallet.png",
      },
    ],
    [
      {
        value: ChillPayPaymentChannel.EWallet_ShopeePay,
        name: "ShopeePay",
        imgUrl: urlImg + "EwalletLogo/Shopee.png",
      },
    ],
    [
      {
        value: ChillPayPaymentChannel.EWallet_AliPay,
        name: "AliPay",
        imgUrl: urlImg + "EwalletLogo/Alipay.png",
      },
    ],
    [
      {
        value: ChillPayPaymentChannel.EWallet_WeChatPay,
        name: "WeChat Pay",
        imgUrl: urlImg + "EwalletLogo/Wechat.png",
      },
    ],
  ];

  @StoreMerchant.Getter
  private getMerchantQRPaymentModel!: any;
  @StoreMerchant.Getter
  private getMerchantQRPaymentSettingLoadingStatus!: LoadingStatusType;

  @StoreMerchant.Action
  private DoGetQRPaymentSetting!: () => void;
  @StoreLoading.Action
  private IsLoading!: (input: boolean) => void;
  @StoreAlert.Action
  private SetAlertMessage!: (input: any) => void;
  @StorePayment.Action
  private DoGetChillPayPayment!: (input: ChillPayRequestModel) => void;

  created() {
    this.GetQRPaymentSetting();
  }

  get isPaymentDisabled() {
    return false;
  }

  @Watch("pickMainPaymentChannel")
  pickMainPaymentChannelChanged() {
    this.PreparePaymentChannelList(this.pickMainPaymentChannel);
  }

  @Watch("showModal")
  showModalChanged() {
    if (!this.showModal) {
      this.HideModal();
    }
  }

  @Watch("getMerchantQRPaymentSettingLoadingStatus")
  getMerchantQRPaymentSettingLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.PrepareMainPaymentChannelList();
    }
  }

  public PrepareMainPaymentChannelList() {
    this.paymentChannel = [];
    this.mainPaymentChannel = [];

    if (this.getMerchantQRPaymentModel && this.getMerchantQRPaymentModel.chillPayPaymentCodeModel) {
      const mockPaymentChannelList = this.getMerchantQRPaymentModel.chillPayPaymentCodeModel.paymentChannel;
      for (let count = 0; count < mockPaymentChannelList.length; count++) {
        const chillPayPaymentChannel = [];
        chillPayPaymentChannel.push({
          value: mockPaymentChannelList[count],
          name: this.GetNameMainPaymentChannel(mockPaymentChannelList[count]),
          icon: this.GetNameIconPaymentChannel(mockPaymentChannelList[count]),
        });
        this.mainPaymentChannel.push(chillPayPaymentChannel);
      }
    }
  }

  public PreparePaymentChannelList(type: ChillPayMainPaymentChannel) {
    this.paymentChannel = [];
    this.pickPaymentChannel = ChillPayPaymentChannel.None;

    switch (type) {
      case ChillPayMainPaymentChannel.QRPromptPay:
        break;
      case ChillPayMainPaymentChannel.CreditDebitCard:
        break;
      case ChillPayMainPaymentChannel.InternetBanking:
        this.paymentChannel = this.internetBanking;
        this.pickPaymentChannel = ChillPayPaymentChannel.InternetBank_Bay;
        break;
      case ChillPayMainPaymentChannel.MobilePayment:
        this.paymentChannel = this.mobilePayment;
        this.pickPaymentChannel = ChillPayPaymentChannel.MobileBank_Scb;
        break;
      case ChillPayMainPaymentChannel.EWallet:
        this.paymentChannel = this.eWallet;
        this.pickPaymentChannel = ChillPayPaymentChannel.EWallet_LinePay;
        break;
    }
  }

  public GetNameMainPaymentChannel(type: number) {
    switch (type) {
      case ChillPayMainPaymentChannel.QRPromptPay:
        return this.$t("ChillPay_PaymentChannel.QRPayment");
      case ChillPayMainPaymentChannel.CreditDebitCard:
        return this.$t("ChillPay_PaymentChannel.CreditDebitCard");
      case ChillPayMainPaymentChannel.InternetBanking:
        return this.$t("ChillPay_PaymentChannel.Internet_Banking");
      case ChillPayMainPaymentChannel.MobilePayment:
        return this.$t("ChillPay_PaymentChannel.Mobile_Banking");
      case ChillPayMainPaymentChannel.EWallet:
        return this.$t("ChillPay_PaymentChannel.E_Wallet");
      default:
        return "";
    }
  }

  public GetNameIconPaymentChannel(type: number) {
    switch (type) {
      case ChillPayMainPaymentChannel.QRPromptPay:
        return "fas fa-qrcode";
      case ChillPayMainPaymentChannel.CreditDebitCard:
        return "fas fa-credit-card";
      case ChillPayMainPaymentChannel.InternetBanking:
        return "fas fa-university";
      case ChillPayMainPaymentChannel.MobilePayment:
        return "fas fa-mobile-alt";
      case ChillPayMainPaymentChannel.EWallet:
        return "fas fa-wallet";
      default:
        return "";
    }
  }

  public GetQRPaymentSetting() {
    this.DoGetQRPaymentSetting();
  }

  public GetChillPayPayment() {
    const input: ChillPayRequestModel = {
      transactionId: this.transactionId,
      transactionTypeId: this.transactionType,
      paymentChannelType: this.PreparePaymentChannelType(),
    };
    this.DoGetChillPayPayment(input);
  }

  public PreparePaymentChannelType() {
    let type: number = 1;

    switch (this.pickMainPaymentChannel) {
      case ChillPayMainPaymentChannel.QRPromptPay:
        type = ChillPayPaymentChannel.QRPayment;
        break;
      case ChillPayMainPaymentChannel.CreditDebitCard:
        type = ChillPayPaymentChannel.CreditCard;
        break;
      case ChillPayMainPaymentChannel.InternetBanking:
        type = this.pickPaymentChannel;
        break;
      case ChillPayMainPaymentChannel.MobilePayment:
        type = this.pickPaymentChannel;
        break;
      case ChillPayMainPaymentChannel.EWallet:
        type = this.pickPaymentChannel;
        break;
    }

    return type;
  }

  public SubmitToPaySolutions() {
    this.IsLoading(true);
    this.isShowFormSubmit = true;

    setTimeout(() => {
      const formSubmit: any = this.$refs.formSubmit;
      formSubmit.submit();
    }, 0);
  }

  public GetIconPaymentChannel(type: number) {
    switch (type) {
      case ChillPayPaymentChannel.InternetBank_Bay:
        return "";
      case ChillPayPaymentChannel.InternetBank_Bbl:
        return "";
      case ChillPayPaymentChannel.InternetBank_Scb:
        return "";
      case ChillPayPaymentChannel.InternetBank_Ktb:
        return "";
      case ChillPayPaymentChannel.InternetBank_Ttb:
        return "";
      case ChillPayPaymentChannel.PayPlus_Kbank:
        return "";
      case ChillPayPaymentChannel.MobileBank_Scb:
        return "";
      case ChillPayPaymentChannel.MobileBank_Bay:
        return "";
      case ChillPayPaymentChannel.MobileBank_Bbl:
        return "";
      case ChillPayPaymentChannel.MobileBank_Ktb:
        return "";
      case ChillPayPaymentChannel.CreditCard:
        return "fas fa-credit-card";
      case ChillPayPaymentChannel.EWallet_AliPay:
        return "";
      case ChillPayPaymentChannel.EWallet_WeChatPay:
        return "";
      case ChillPayPaymentChannel.EWallet_LinePay:
        return "";
      case ChillPayPaymentChannel.EWallet_TrueMoney:
        return "";
      case ChillPayPaymentChannel.EWallet_ShopeePay:
        return "";
      case ChillPayPaymentChannel.QRPayment:
        return "fas fa-qrcode";
      case ChillPayPaymentChannel.BillPayment_CenPay:
        return "";
      case ChillPayPaymentChannel.BillPayment_Counter:
        return "";
      case ChillPayPaymentChannel.Installment_Kbank:
        return "";
      case ChillPayPaymentChannel.Installment_Ktc_Flexi:
        return "";
      case ChillPayPaymentChannel.Installment_Krungsri:
        return "";
      case ChillPayPaymentChannel.Installment_FirstChoice:
        return "";
      case ChillPayPaymentChannel.Installment_Scb:
        return "";
      case ChillPayPaymentChannel.Kiosk_Machine:
        return "";
      case ChillPayPaymentChannel.PayWithPoints:
        return "";
    }
  }

  public GetNamePaymentChannel(type: number) {
    switch (type) {
      case ChillPayPaymentChannel.InternetBank_Bay:
        return "Internet Banking BAY";
      case ChillPayPaymentChannel.InternetBank_Bbl:
        return "Internet Banking BBL";
      case ChillPayPaymentChannel.InternetBank_Scb:
        return "Internet Banking SCB";
      case ChillPayPaymentChannel.InternetBank_Ktb:
        return "Internet Banking KTB";
      case ChillPayPaymentChannel.InternetBank_Ttb:
        return "Internet Banking TTB";
      case ChillPayPaymentChannel.PayPlus_Kbank:
        return "Mobile Banking Kbank";
      case ChillPayPaymentChannel.MobileBank_Scb:
        return "Mobile Banking SCB";
      case ChillPayPaymentChannel.MobileBank_Bay:
        return "Mobile Banking BAY";
      case ChillPayPaymentChannel.MobileBank_Bbl:
        return "Mobile Banking BBL";
      case ChillPayPaymentChannel.MobileBank_Ktb:
        return "Mobile Banking KTB";
      case ChillPayPaymentChannel.CreditCard:
        return "Credit Card";
      case ChillPayPaymentChannel.EWallet_AliPay:
        return "E-Wallet Alipay";
      case ChillPayPaymentChannel.EWallet_WeChatPay:
        return "E-Wallet WeChat Pay";
      case ChillPayPaymentChannel.EWallet_LinePay:
        return "E-Wallet Rabbit LINE Pay";
      case ChillPayPaymentChannel.EWallet_TrueMoney:
        return "E-Wallet TrueMoney";
      case ChillPayPaymentChannel.EWallet_ShopeePay:
        return "E-Wallet ShopeePay";
      case ChillPayPaymentChannel.QRPayment:
        return "QR Payment";
      case ChillPayPaymentChannel.BillPayment_CenPay:
        return "Bill Payment CenPay";
      case ChillPayPaymentChannel.BillPayment_Counter:
        return "Counter Bill Payment";
      case ChillPayPaymentChannel.Installment_Kbank:
        return "ผ่อนชำระผ่านทางธนาคารกสิกร";
      case ChillPayPaymentChannel.Installment_Ktc_Flexi:
        return "ผ่อนชำระผ่านทาง KTC FLEXI";
      case ChillPayPaymentChannel.Installment_Krungsri:
        return "ผ่อนชำระผ่านทาง Krungsri Consumer";
      case ChillPayPaymentChannel.Installment_FirstChoice:
        return "ผ่อนชำระผ่านทาง First Choice";
      case ChillPayPaymentChannel.Installment_Scb:
        return "ผ่อนชำระผ่านทางธนาคารไทยพาณิชย์";
      case ChillPayPaymentChannel.Kiosk_Machine:
        return "ช่องทางชำระเงินผ่าน ตู้บุญเติม";
      case ChillPayPaymentChannel.PayWithPoints:
        return "ใช้คะแนนสะสมผ่าน KTC FOREVER";
    }
  }

  public HideModal() {
    this.$emit("update:showModal", false);
  }
}
